<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "RegionIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
